<ng-template [ngIf]="formattableText">{{
	formattableText | translate: { hours: hours, minutes: minutes, seconds: seconds }
}}</ng-template>
